/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FirefoxAmoInstallStats interface.
 */
export function instanceOfFirefoxAmoInstallStats(value) {
    if (!('averageDailyUsers' in value) || value['averageDailyUsers'] === undefined)
        return false;
    if (!('isDisabled' in value) || value['isDisabled'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('weeklyDownloads' in value) || value['weeklyDownloads'] === undefined)
        return false;
    return true;
}
export function FirefoxAmoInstallStatsFromJSON(json) {
    return FirefoxAmoInstallStatsFromJSONTyped(json, false);
}
export function FirefoxAmoInstallStatsFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'averageDailyUsers': json['averageDailyUsers'],
        'isDisabled': json['isDisabled'],
        'status': json['status'],
        'weeklyDownloads': json['weeklyDownloads'],
    };
}
export function FirefoxAmoInstallStatsToJSON(json) {
    return FirefoxAmoInstallStatsToJSONTyped(json, false);
}
export function FirefoxAmoInstallStatsToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'averageDailyUsers': value['averageDailyUsers'],
        'isDisabled': value['isDisabled'],
        'status': value['status'],
        'weeklyDownloads': value['weeklyDownloads'],
    };
}
